import { writable } from 'svelte/store';
import * as util from '../js/util.js';

function createMyStore() {
    const { subscribe, set, update } = writable({ subSections: new Array(), variables: new Array(), availableLangs: [] });

    return {
        subscribe, update,
        getCalculator: async (countryVersionId) => {
            const json = await util.fetchJson('api/Country/getcalculatorconfig?countryVersionId=' + countryVersionId);
            update(n => json)
            return json
        },
    };
}
export const calculatorStore = createMyStore(); 